import classNames from "classnames";
import { IRichMarkdownRef, RichMarkdownEditor } from "lucy/common-components";
import * as React from "react";
import { Button, Input, Label, Modal } from "uxp/components";
import { parseValue } from "../../../../util";
import { IBaseProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import MarkdownView from "./MarkdownView";
import './markdown.scss';
import { IContextProvider } from "../../../../uxp";
interface IMarkdownFieldProperty extends IBaseProperty {
	text: string;
}

export const Field: React.FunctionComponent<IUIFieldProps<IMarkdownFieldProperty>> = (props) => {

	let text = props?.fieldProps?.text || '';

	return (
		<div className={classNames('ui-field', props.mode)} >
			<div className='widget-designer-field-markdown'>

			</div>
			<Label className="widget-designer-field-label">
				<MarkdownView text={text} />
			</Label>
		</div >
	)
}

interface IRichTextModalProps {
	uxpContext: IContextProvider,
	show: boolean,
	onClose: () => void,
	value: string,
	onChange: (v: string) => void
}

export const RichTextModal: React.FunctionComponent<IRichTextModalProps> = (props) => {
	const editorRef = React.useRef<IRichMarkdownRef>(null);

	return (
		<Modal
			className={'wd-rich-text-editor-modal'}
			show={props.show}
			onClose={props.onClose}
			title={'Rich Text Editor'}
		>
			<div className="content">
				<RichMarkdownEditor
					uxpContext={props.uxpContext}
					onChange={props.onChange}
					onSave={(x) => {
						props.onChange(x)
						props.onClose()
					}}
					className='readme-editor'
					editorRef={editorRef}
					markdown={props.value}
				/>
			</div>
		</Modal>
	)
}


interface IRichTextPropertyProps {
	uxpContext: IContextProvider,
	value: string,
	onChange: (v: string) => void
	title?: string,
	hideInputBox?: boolean
}


export const CommonRichTextProperty: React.FunctionComponent<IRichTextPropertyProps> = (props) => {
	const [showEditor, setShowEditor] = React.useState<boolean>(false)

	return <div className='wd-prop-item'>

		<RichTextModal
			show={showEditor}
			onClose={() => setShowEditor(false)}
			value={props.value || ''}
			onChange={props.onChange}
			uxpContext={props.uxpContext}
		/>

		<div className='wd-prop-item-title'>{props.title || 'Rich Text'}</div>
		<div className='wd-prop-item-editor'>
			<Label>{'Value'}</Label>

			{
				!props.hideInputBox && <textarea rows={4}
					value={props.value || ''}
					onChange={(evt) => props.onChange(evt.target.value)}
					className="uxp-form-input"
				/>
			}

			<Button
				title={'Show editor'}
				onClick={() => { setShowEditor(true) }}
				icon="/Resources/Lucy/lucy-dashboard/assets/images/uxp-card.svg"
				iconPosition="right"
			/>
		</div>

	</div>;
}


export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<IMarkdownFieldProperty>> = (props) => {
	const [showEditor, setShowEditor] = React.useState<boolean>(false)

	return (
		<CommonRichTextProperty
			value={props.uiProps.text || ''}
			onChange={v => props.onChange(Object.assign({}, props.uiProps, { text: v }))}
			uxpContext={props.uxpContext}
			title={'Rich Text'} />
	)

}

registerUIField({
	id: 'markdown',
	description: 'Rich Text',
	field: Field,
	propertyEditor: PropertyEditor,
	defaultProps: {
		text: '# Rich Text\nGoes here\n![](https://static.iviva.com/lucy/logos/lucy-canvas-2.png)\n## Section 1\n* Item 1\n* Item 2\n* Item 3\n\n',
	},
	type: 'notes'
});

